import React from 'react'

import {
  type FirstExperienceModalStep,
  FirstExperienceModal,
} from 'components/FirstExperienceModal'

import LiveChatJourney from './images/1_livechatjourney.svg'
import HighLevelOutcomes from './images/2_highleveloutcomes.svg'
import Details from './images/3_seethedetails.svg'

const propertyName = 'hasDismissedRoutingOutcomesReportFirstExperience'
const featureCreatedDate = new Date('2023-02-10')

const LiveChatJourneyStep: FirstExperienceModalStep = {
  header: 'Live chat journey',
  description:
    'Understand what is happening when a site visitor wants to speak to a human. Do these visitors get connected? What happens when they don’t? How many chats are missed?',
  imageProps: {
    src: LiveChatJourney,
    alt: 'Live chat journey',
  },
}

const HighLevelOutcomesStep: FirstExperienceModalStep = {
  header: 'High level outcomes',
  description:
    'Understand how many routed chats get responses, how fast teammates are responding, and how many routed chat visitors get dead ended (no reponse or fallback.)',
  imageProps: {
    src: HighLevelOutcomes,
    alt: 'High level outcomes',
  },
}

const DetailsStep: FirstExperienceModalStep = {
  header: 'See the details',
  description: 'Drilldown into any data point to dive deeper into the chats.',
  imageProps: {
    src: Details,
    alt: 'Details',
  },
}

export const RoutingFirstExperienceModal = () => (
  <FirstExperienceModal
    propertyName={propertyName}
    featureCreatedDate={featureCreatedDate}
    steps={[LiveChatJourneyStep, HighLevelOutcomesStep, DetailsStep]}
  />
)
